<template>
  <div>
    <div
      class="tile is-parent"
      style="max-width: 500px; margin: auto; margin-top: 50px"
    >
      <article class="tile is-child box" style>
        <div class="content">
          <div id="check" />
          <h2 style="text-align: center; margin-top: 0px">{{ title }}</h2>
          <p
            style="text-align: center"
            v-for="text in texts"
            v-bind:key="'text' + text.str"
          >
            {{ text.str }}
          </p>
        </div>
        <img
          height="1"
          width="1"
          style="display: none"
          alt=""
          src="https://px.ads.linkedin.com/collect/?pid=1886684&conversionId=1933121&fmt=gif"
        />
      </article>
    </div>
    <!-- <h2 style="margin-top: 30px; text-align: center;">Congratulations, you've been approved!</h2> -->
    <!-- <div class="tile is-parent" style="max-width: 500px; margin: auto;"> -->
    <!-- <article class="tile is-child box" style="">
        <div class="content">
          <p class="title" style="text-align: center;">$100,000</p>
          <hr />
          <div class="level is-mobile">
            <div class="level-left">
              <strong>Specified Percentage</strong>
            </div>
            <div class="level-right">
              8%
            </div>
          </div>
          <div class="level is-mobile">
            <div class="level-left">
              <strong>Term</strong>
            </div>
            <div class="level-right">
              12 months
            </div>
          </div>
          <div class="level is-mobile">
            <div class="level-left">
              <strong>Weekly Payment</strong>
            </div>
            <div class="level-right">
              $2,153.85
            </div>
          </div>
        </div>
    </article>-->
    <!-- </div> -->
    <!-- <div class="buttons is-centered" style="margin-top: 30px;">
      <a class="button is-link padded-button next-button" @click="next">Withdraw Funds</a>
    </div>-->
  </div>
</template>

<script>
function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}
import Input from "@/components/shared/Input";
import ApplyPage from "@/components/shared/ApplyPage";
import $ from "jquery";
export default {
  name: "Approval",
  components: {},
  props: {
    texts: Array,
    title: String,
  },
  mixins: [ApplyPage],
  data() {
    return {};
  },
  mounted: function () {
    console.log("mounted approval.vue");

    // var ecData = {
    //   email: window.custom_data.email,
    //   phone_number: window.custom_data.phone_number,
    //   first_name: window.custom_data.first_name,
    //   last_name: window.custom_data.last_name,
    //   home_address: {
    //     street: window.custom_data.street,
    //     city: window.custom_data.city,
    //     region: window.custom_data.state,
    //     postal_code: window.custom_data.postal_code,
    //     country: "us",
    //   },
    // };

    // let monthly_sales = getWithExpiry("monthly_sales");
    // console.log("monthly_sales: " + monthly_sales);
    // let monthly_sales_float = 0;
    // if (monthly_sales && monthly_sales != "") {
    //   monthly_sales_float = parseFloat(monthly_sales.replace(/,/g, ""));
    // }

    // if (monthly_sales_float >= 10000) {
    //   this.$gtm.trackEvent({
    //     event: "complete_app",
    //     ecData: ecData,
    //     // category: 'Contact Form',
    //     // action: 'click',
    //     // label: 'Contact Form Complete',
    //     // value: 5000
    //   });
    // }

    for (var i = 0; i < 80; i++) {
      create(i);
    }

    function create(i) {
      var width = Math.random() * 20;
      var height = width * 0.4;
      var colour = "green";

      $('<div class="confetti-' + i + " " + colour + '"></div>')
        .css({
          width: width + "px",
          height: height + "px",
          top: -Math.random() * 20 + "%",
          left: Math.random() * 100 + "%",
          opacity: Math.random() + 0.5,
          transform: "rotate(" + Math.random() * 360 + "deg)",
        })
        .appendTo("#app");
      drop(i);
    }

    function drop(x) {
      $(".confetti-" + x).animate(
        {
          top: "100%",
          left: "+=" + Math.random() * 15 + "%",
        },
        Math.random() * 3000 + 2000,
        function () {
          $(".confetti-" + x).remove();
        }
      );
    }

    var animation = lottie.loadAnimation({
      container: document.getElementById("check"), // the dom element that will contain the animation
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: "../animations/check.json", // the path to the animation json
    });
    setTimeout(function () {
      animation.play();
    }, 500);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
[class|="confetti"] {
  position: absolute;
}

.green {
  background-color: #3cb968;
}

.level {
  margin-bottom: 10px !important;
}
#check {
  max-width: 20%;
  margin: auto;
  display: block;
}
</style>
